import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import * as serviceWorker from './serviceWorker';
import "@/static/css/reset.css"
import Index from "@/pages/index/index"
import "@/static/font/AlibabaPuHuiTiB/index.scss"

ReactDOM.render(
  <React.StrictMode>
    <Router>
        <Switch>
            <Route path="/" exact component={Index}></Route>
        </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
